import TermConfidentialityAndDataProtection1 from './list/TermConfidentialityAndDataProtection1'
import TermUseHospitalEquipment from './list/TermUseHospitalEquipment'
import TermAcceptanceCompliance from './list/TermAcceptanceCompliance'
import TermRegistrationAndConfidentialityOfTheRecordsAndPortalLaboratoryTestsAndDiagnoses from './list/TermRegistrationAndConfidentialityOfTheRecordsAndPortalLaboratoryTestsAndDiagnoses'

export default function DoctorTerms() {
  const terms = [
    TermConfidentialityAndDataProtection1(),
    TermUseHospitalEquipment(),
    TermAcceptanceCompliance(),
    TermRegistrationAndConfidentialityOfTheRecordsAndPortalLaboratoryTestsAndDiagnoses()
  ]

  return terms
}
